module.exports = __webpack_public_path__ + "assets/6f820113f3cfdea493945dde3da56854.mp3";